// SemanticUI-free pre-@plone/components

import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { UniversalLink, Logo, Image } from '@plone/volto/components';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers';
import mitecolLogo from '../../../../images/MITECOLogo.png';
import bscLogo from '../../../../images/BSC-white-large.png';
import aemetLogo from '../../../../images/aemet_inst_neg_rgb.png';
import pRecuperacionLogo from '../../../../images/logo-plan-recuperacion.png';
import rLogo from '../../../../images/r.png';
import ueLogo from '../../../../images/ueLogo.png';
import config from '@plone/volto/registry';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { settings } = config;
  const { pathname } = useLocation();
  const { lang, siteActions = [] } = useSelector(
    (state) => ({
      lang: state.intl.locale,
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );
  // La página CAMS NCP no muestra footer (usa sus propios logos de financiación)
  if (pathname.replace(/\/+$/, '') === '/cams-ncp') {
    return null;
  }
  return (
    <footer id="footer">
      <div className="footer">
        <div className="max-width-footer">
          <Image src={ueLogo} alt="UE Logo" />
          <Image src={mitecolLogo} alt="Mitecol Logo" />
          <Image src={rLogo} alt="R Logo" />
          <Image src={aemetLogo} alt="Aemet Logo" />
          <Image src={bscLogo} alt="BSC Logo" />
        </div>
        <div className="footer-separator"></div>
        <div className="footer-content">
          <div className="footer-contact">
            Contacto
            <span>respire@bsc.es</span>
          </div>
          <div className="footer-branding">
            <p style={{ color: 'white' }}>
              &copy; 2026 BSC. All rights reserved.
            </p>
            <div className="footer-links">
              <UniversalLink href="https://ess.bsc.es/privacy-policy">
                Privacy Policy
              </UniversalLink>
              <UniversalLink href="https://www.bsc.es/es/aviso-legal">
                Legal Notice
              </UniversalLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
